import { useMutation } from '@tanstack/react-query'

import { CreateCadastrarClienteService } from '@/features/clientes/services/post-cadastrar-cliente.service'
import { cadastrarClienteKeys } from '@/features/clientes/utils'
import type { TCreateCadastrarClienteData, TCreateCadastrarClienteResponse } from '@/shared/interfaces/cliente.types'
import type { AxiosErrorMap } from '@/shared/lib/http/axios-adapter'

export const useMutationCadastrarCliente = () => {
  return useMutation<TCreateCadastrarClienteResponse, AxiosErrorMap, Partial<TCreateCadastrarClienteData>>({
    mutationKey: cadastrarClienteKeys.cadastrar(),
    mutationFn: async (cadastro: Partial<TCreateCadastrarClienteData>) => {
      const response = await new CreateCadastrarClienteService().execute(cadastro)
      return response.data
    },
  })
}
